import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../components/Modal/Modal';
import { setDialogState } from '../../reduxStore/reducers/dialogSlice';
import { useState } from 'react';
import { useFormik } from 'formik';
import { resetPassword } from 'reduxStore/actions/auth';
import NewPasswordComponent from './component/NewPassword';
import * as Yup from 'yup';
import { new_pass_text1, set_new_pass, validation } from './constants/text';

const NewPassword = () => {
  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);
  const dispatch = useDispatch();
  const [passwordHide, setPasswordHide] = useState({
    password: true,
    confirmPassword: true,
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      password:Yup.string().min(8, 'Password must be at least 8 characters long')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .matches(
        /[@$!%*?&#]/,
        'Password must contain at least one special character (@, $, !, %, *, ?, &)'
      )
      .trim().required(validation.password_required),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], validation.confirmPassword_match)
        .required(validation.confirmPassword_required),
    }),
    onSubmit: (values) => {
      onSubmit();
    },
  });

  const handleHidePasswords = (name) => {
    setPasswordHide({
      ...passwordHide,
      [name]: !passwordHide[name],
    });
  };

  const onSubmit = () => {
    const storedEmail = localStorage.getItem('email');

    const params ={
      password: formik.values.password,
      confirmPassword: formik.values.confirmPassword,
     email: storedEmail,
      
    };
    dispatch(resetPassword(params))
    .unwrap()
    .then((response) => {
      dispatch(
        setDialogState({
          ...dialogOpenState,
          newPassword: false,
        })
      );
    })
  };

  return (
    <Modal
      modalContentClassname={'sm:min-w-[490px] max-h-[90vh] overflow-y-auto sidebar-scrollbar '}
      title={set_new_pass}
      disableOutsideClick={true}
      closeHandler={() =>
        dispatch(
          setDialogState({
            ...dialogOpenState,
            newPassword: false,
          })
        )
      }
      text={new_pass_text1}
      children={
        <NewPasswordComponent
          formik={formik}
          passwordHide={passwordHide}
          handleHidePasswords={(name) => handleHidePasswords(name)}
          onSubmit={(e) => formik.handleSubmit()}
        />
      }
    />
  );
};

export default NewPassword;
